import { Directive, ElementRef, HostBinding, HostListener, Input, NgModule, Optional, Inject } from '@angular/core';
import { Constants } from '@app/common/constants';
import { TrackingEvent } from '@app/models/tracking-event';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { BaseTrackingService } from '@app/tracking/base-tracking.service';
import { Utilities } from '@app/common/utilities';
import { WINDOW } from '@app/common/app-tokens';

@Directive({
  /* tslint:disable */
  selector: 'a:not([routerLink])',
  /* tslint:enable */
})
export class LinkDirective {

  @Input() componentId: string;

  @HostBinding('rel') @Input() rel = 'noopener';

  @HostBinding('target') @Input() target = '_blank';

  parentElement: HTMLElement;

  constructor(
    private featureSettingsStoreService: FeatureSettingsStoreService,
    private elementRef: ElementRef,
    @Inject(WINDOW) private window: Window,
    @Optional() private trackingService?: BaseTrackingService) {
      const targetElement = this.elementRef.nativeElement as HTMLElement;
      const parentElement = this.getParentComponentElementThatStartWithPrefix(targetElement, 'app-app-tile-box');
      const componentIdentifier = parentElement && parentElement.localName.toLowerCase();

    // If openAllLinksInSameTab setting is enabled, then change the target attribute of the link to "_self"
      if ((this.featureSettingsStoreService.state.openAllLinksInSameTab || Utilities.isInTeamsApp(this.window)) && !componentIdentifier) {
      this.target = '_self';
    }
      if (this.featureSettingsStoreService.state.openAppAndToolsInSameTab  && componentIdentifier) {
      this.target = '_self';
    }
  }

  @HostListener('click') onClick() {
    if (this.trackingService && this.trackingService.trackEvent) {
      const targetElement = this.elementRef.nativeElement as HTMLElement;
      if (targetElement) {
        const hrefAttribute = targetElement.attributes.getNamedItem('href');

        const href = hrefAttribute ? hrefAttribute.value : null;
        let componentIdentifier = this.componentId;

        if (!componentIdentifier) {
          this.parentElement = this.getParentComponentElementThatStartWithPrefix(targetElement, 'app-');
          componentIdentifier = this.parentElement && this.parentElement.localName.toLowerCase();
        }

        const trackingEvent = new TrackingEvent({
          name: Constants.TRACKING_EVENT_TYPE_LINK_CLICK,
          properties: {
            href: href,
            componentId: componentIdentifier
          }
        });

        if (targetElement.innerText && targetElement.innerText !== '') {
          const innerTxtArr = targetElement.innerText.split('\n');
          trackingEvent.properties.label = innerTxtArr.join(', ');
        }

        if (componentIdentifier === 'app-app-tile-box') {
          trackingEvent.properties.label = this.parentElement && this.parentElement.innerText;
          trackingEvent.name = Constants.TRACKING_EVENT_TYPE_APP_CLICK;
        }

        this.trackingService.trackEvent(trackingEvent);
      }
    }
  }

  getParentComponentElementThatStartWithPrefix(el: HTMLElement, str: string): HTMLElement {
    if (el) {
      if (el.localName.toLowerCase().startsWith(str.toLowerCase())) {
        return el;
      } else {
        return this.getParentComponentElementThatStartWithPrefix(el.parentElement, str);
      }
    }
  }

}
@NgModule({
  declarations: [LinkDirective],
  exports: [LinkDirective],
})
export class LinkModule { }
